var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error404"},[_c('p',[_vm._v(_vm._s(_vm.$t('error404')))]),_c('p',[_c('a',{staticClass:"btn btn__view",attrs:{"href":("/" + (this.$store.getters.language))}},[_vm._v("Home")])])])}
var staticRenderFns = []

export { render, staticRenderFns }